import User from "../../../client/models/user"

export type CommentableType = 'Question' | 'Inquiry' | 'Course' | 'Blog' | 'Answer' | 'UserExam' | 'Lesson'

export interface Commentable{
  commentableId: number
  commentableType: CommentableType
}
export default class Comment {
  readonly id: number
  readonly user: User
  readonly createdAt: string
  readonly updatedAt: string
  readonly renderedBody: string
  body: string
  isEditing: boolean = false

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.body = data.body
    this.renderedBody = data.renderedBody
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.isEditing = false

    if (data.user) {
      this.user = new User(data.user)
    }
  }
}
